import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ListResponse } from '@daikin-tic/dxone-com-lib';

import { Project, ProjectQueryParams } from '../models/project.model';
import { ProjectGateway } from '../usecases/project.gateway';

@Injectable()
export class ProjectService extends ProjectGateway {
  constructor(private _http: HttpClient) {
    super();
  }

  listProjects(params: ProjectQueryParams): Observable<ListResponse<Project>> {
    return this._http.get<ListResponse<Project>>('api/vgs/projects', { params });
  }
}
